import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanInstalmentPaymentStatus extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanInstalmentPaymentStatus';
}
